module.exports = __webpack_public_path__ + "img/circle-yellow-.3b1a3571.png";